import { useQuery } from '@tanstack/react-query';

import { getCartsByUser } from '~/services/CartService';

import { GetUserCartsParams, GetUserCartsResponse } from '~/types/services/carts';

export const cartsQueryKeys = {
  all: ['carts'],
  userLists: () => [...cartsQueryKeys.all, 'user-list'],
  userList: (userId: string, params: GetUserCartsParams) => [...cartsQueryKeys.userLists(), userId, params],
};

interface UseListUserCartsOptions {
  enabled: boolean;
}

export function useListUserCarts(userId: string, params: GetUserCartsParams, options: UseListUserCartsOptions) {
  const { enabled } = options;

  return useQuery<GetUserCartsResponse>({
    placeholderData: (prev) =>
      prev ?? {
        status: 200,
        total: 0,
        count: 0,
        result: [],
      },
    queryKey: cartsQueryKeys.userList(userId, params),
    queryFn: async ({ signal }) => {
      return await getCartsByUser(userId, params, { signal });
    },
    enabled,
  });
}
